import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Typography from '@mui/material/Typography';


const CompanyBlock = () => {



    return (
        <div className="App-header">
                
                    <div style={{ width: '80%', justifyContent: 'space-evenly', flexDirection: 'column', alignItems: 'center', height: '500px', display: 'flex' }}>
                       
                        
                        {/* Logo and Heading */}

                        <div style={{ width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex', color: '#10406B' }}>
                            <Typography variant="h5" component="h1" sx={{
                                color:'#10406B',
                                fontFamily:"'Tajawal', sans-serif",
                                fontStyle:'bold'
                            }} >
                                شركة السلام العامة
                            </Typography>
                            <Typography paragraph={true} component="p" sx={{
                                color:'#10406B',
                                fontFamily:"'Tajawal', sans-serif",
                                fontStyle:'normal',
                                marginTop:'10px',
                                textAlign: 'center'
                            }} >
                                هي احدى تشكيلات وزارة الاتصالات والتي تهدف الى الإسهام في دعم الاقتصاد الوطني و تنمية و تطوير قطاع أمن الاتصالات و تكنلوجيا المعلومات و تقديم افضل الخدمات الحكومية الى المؤسسات و المواطنين في مجال التحول الرقمي ضمن أعلى معايير الجودة

                            </Typography>
                            
                        </div>

                        <div style={{ width: '100%', justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            <div
                                className="service-card"
                           
                            >
                                <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    fontStyle:'bold',
                                    textAlign: 'center'
                                }} >
                                    شركة السلام العامة
                                </Typography>
                                
                                    <Typography paragraph={true} component="p" sx={{
                                        color:'#10406B',
                                        fontFamily:"'Tajawal', sans-serif",
                                        fontStyle:'normal',
                                        marginTop:'10px',
                                        textAlign: 'justify',
                                        textJustify: 'inter-word'
                                    }} >
                                        هي احدى تشكيلات وزارة الاتصالات والتي تهدف الى الإسهام في دعم الاقتصاد الوطني و تنمية و تطوير قطاع أمن الاتصالات و تكنلوجيا المعلومات و تقديم افضل الخدمات الحكومية الى المؤسسات و المواطنين في مجال التحول الرقمي ضمن أعلى معايير الجودة

                                    </Typography>
                                
                            </div>
                            
                            <div
                                className="service-card"
                            >
                                <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    fontStyle:'bold',
                                    textAlign: 'center'
                                }} >
                                    شركة السلام العامة
                                </Typography>
                                
                                    <Typography paragraph={true} component="p" sx={{
                                        color:'#10406B',
                                        fontFamily:"'Tajawal', sans-serif",
                                        fontStyle:'normal',
                                        marginTop:'10px',
                                        textAlign: 'justify',
                                        textJustify: 'inter-word'

                                    }} >
                                        هي احدى تشكيلات وزارة الاتصالات والتي تهدف الى الإسهام في دعم الاقتصاد الوطني و تنمية و تطوير قطاع أمن الاتصالات و تكنلوجيا المعلومات و تقديم افضل الخدمات الحكومية الى المؤسسات و المواطنين في مجال التحول الرقمي ضمن أعلى معايير الجودة

                                    </Typography>
                            </div>
                            <div
                                className="service-card"
                             
                            >
                              <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    fontStyle:'bold',
                                    textAlign: 'center'
                                }} >
                                    شركة السلام العامة
                                </Typography>
                                
                                    <Typography paragraph={true} component="p" sx={{
                                        color:'#10406B',
                                        fontFamily:"'Tajawal', sans-serif",
                                        fontStyle:'normal',
                                        marginTop:'10px',
                                        textAlign: 'justify',
                                        textJustify: 'inter-word'
                                    }} >
                                        هي احدى تشكيلات وزارة الاتصالات والتي تهدف الى الإسهام في دعم الاقتصاد الوطني و تنمية و تطوير قطاع أمن الاتصالات و تكنلوجيا المعلومات و تقديم افضل الخدمات الحكومية الى المؤسسات و المواطنين في مجال التحول الرقمي ضمن أعلى معايير الجودة

                                    </Typography>
                            </div>
                        </div>

                        
                    </div>
                </div>
            
    )
}


export default CompanyBlock;